(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuConfirmController', OnuConfirmController);

    OnuConfirmController.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'OnuService', 'onuList', 'dataAction'];

    function OnuConfirmController($scope, $rootScope, $uibModalInstance, OnuService, onuList, dataAction) {
        var vm = this;
        vm.requestRunning = false;

        if (dataAction) {
            vm.action = dataAction.action;

            if (onuList.length == 1) {
                vm.onuData = onuList[0];
                vm.itemOne = true;
            } else {
                var names = '';
                var arrayNames = [];
                onuList.forEach(function (olt) {
                    arrayNames.push(olt.name);
                });
                names = arrayNames.join(', ');
                vm.onuData = {
                    amount: onuList.length,
                    names: names
                };
                vm.itemOne = false;
            }

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            };

            vm.confirmAction = function () {
                if (dataAction.confirmation) {
                    vm.close();

                    var postDataAction = {
                        action: dataAction.afterConfirmAction,
                        methodService: dataAction.methodService,
                        methodExtra: dataAction.methodExtra
                    };

                    OnuService.confirmationModalConstructor(onuList, postDataAction);
                } else {
                    vm.requestRunning = true;
                    OnuService[dataAction.methodService](onuList).then(success).catch(error);
                }
            };

        }

        function success(response) {
            vm.requestRunning = false;
            var isMultiple = !vm.itemOne;
            var data = null;

            if (response.status == 207) {
                OnuService.warningModalConstructor(onuList, response, vm.action);
                data = response.data;
            } else {
                OnuService.successModalConstructor(vm.action, isMultiple);
            }

            if (dataAction.methodExtra) {
                dataAction.methodExtra(onuList, data);
            }

            $rootScope.$emit('onuActionSuccess', data);

            OnuService.infoModalConstructor(dataAction);
        }

        function error(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, vm.action);
        }

    }
})();

